<ion-item-divider>
	<div class="appointment">
		<div class="appointment__header" (click)="toggleShowMore()">
			<div class="circle">
				{{ appointment.ticketTypeShortCode || "N/A" }}
			</div>
			<div class="appointment__title">
				{{ appointment.displayValue }}
			</div>
			<div class="appointment__subtitle">
				{{ appointment.ticketCodeDesc }}
			</div>
			<div class="appointment__chevron">
				<ion-icon
					[name]="
						isExpanded
							? 'chevron-up-outline'
							: 'chevron-down-outline'
					"
				></ion-icon>
			</div>
		</div>
		<div class="appointment__travel">
			<button *ngIf="showInWc2; else doNotShowInWc2" class="appointment__address">
				<a href="{{wc2Url}}" target="_blank">
					<div class="appointment__addr1">
						{{ appointment.fullAddress }}
					</div>
					<div class="appointment__addr2">
						<span class="map__icon">
							<ion-icon name="map-outline"></ion-icon>
						</span>
					</div>
				</a>
			</button>
			<ng-template #doNotShowInWc2>
				<div class="appointment__address" *ngIf="appointment.fullAddress; else noAddress">
					<div class="appointment__addr1">
						{{ appointment.fullAddress }}
					</div>
				</div>
			</ng-template>
			<ng-template #noAddress>
				<div class="appointment__address">
					<div class="appointment__addr1">
						No Address Found
					</div>	
				</div>
			</ng-template>
			<div class="appointment__arrival">
				<div class="time" *ngIf="appointment.driveStartTime">
					<span class="time__icon">
						<ion-icon name="flag-outline"></ion-icon>
					</span>
					<span class="time__time">
						{{ appointment.driveStartTime }}
					</span>
				</div>
				<div class="time">
					<span class="time__icon">
						<ion-icon name="flag-outline"></ion-icon>
					</span>
					<span class="time__time">
						{{ getClockTime(appointment.apptStart) }}
					</span>
				</div>
				<div class="time">
					<span class="time__icon">
						<ion-icon name="flag"></ion-icon>
					</span>
					<span class="time__time">
						{{ getClockTime(appointment.apptEnd) }}
					</span>
				</div>
				<div *ngIf="appointment.apptBlockDesc" class="block">
					<span class="block__icon">
						<ion-icon name="pie-chart-outline"></ion-icon>
					</span>
					<span class="block__desc">
						{{ appointment.apptBlockDesc }}
					</span>
				</div>
				<div *ngIf="appointment.ticketPriorityDesc" class="priority">
					<span class="priority__icon">
						<ion-icon name="swap-vertical-outline"></ion-icon>
					</span>
					<span class="priority__desc">
						{{ appointment.ticketPriorityDesc }}
					</span>
				</div>
			</div>
		</div>
		<div
			*ngIf="dataTabPreview"
			class="preview"
			[style]="{ 'max-height': previewMaxHeight + 'px' }"
			#preview
		>
			<div class="data-tab">
				<h2 class="preview__title">{{ dataTabPreview.heading }}</h2>
				<div class="preview__fields">
					<div
						class="field"
						*ngFor="let field of dataTabPreview.fields"
					>
						<span class="field__label">{{ field.label }}:</span>
						<span
							class="field__value"
							[innerHTML]="field.value"
						></span>
					</div>
				</div>
			</div>
		</div>
		<div class="appointment__actions">
			<app-change-status-button
				class="appointment__button"
				[ticketStatusId]="appointment.ticketStatusId"
				[ticketStatusDesc]="appointment.ticketStatusDesc"
				[apptId]="appointment.id"
				expand="full"
			></app-change-status-button>
			<ion-button
				color="light"
				(click)="onClickWorkTicket()"
				class="appointment__button"
				>Work Ticket</ion-button
			>
		</div>
	</div>
</ion-item-divider>
